import { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import CustomButton from '../../../common/CustomButton/CustomButton';
import { Icon } from '../../../common/Icon/Icon';
import Markdown from '../../../common/Markdown/Markdown';
import { slugify } from '../../../core/helpers';

interface IProps {
  item: {
    question: string;
    answer: string;
  };
  isOpen: boolean;
  i: number;
  handleToggle(i: number): void;
}

function FAQItem({ item, isOpen, i, handleToggle }: IProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.setProperty('--faq-item-height', `${ref.current?.scrollHeight}px`);
  }, [isOpen]);

  return (
    <div className={`faq__question${isOpen ? ' open' : ''}`} key={item.question}>
      <CustomButton
        className="faq__btn h4"
        type="button"
        onClick={() => handleToggle(i)}
        id={slugify(item.question)}
      >
        {item.question}
        <Icon.Chevron className={`${isOpen ? 'flip-y' : ''}`} />
      </CustomButton>
      <CSSTransition nodeRef={ref} in={isOpen} timeout={300} classNames="faq-body" unmountOnExit>
        <div className="faq__body" ref={ref}>
          <Markdown className="faq__body-content markdown">{item.answer}</Markdown>
        </div>
      </CSSTransition>
    </div>
  );
}

export default FAQItem;
